import { useCurrentTeamCredits } from "api/payments/useCurrentTeamCredits";
import { FEATURES } from "constants/features";
import { useFlag } from "utils/hooks";

// The Unleash flag carries the allow-list, but Unleash can't see the wallet
// balance, so a listed team with 0 credits must still lose Enrich. Stays false
// while the balance loads (fail closed).
export const useCanEnrich = () => {
  const isFlagOn = useFlag(FEATURES.CONTACT_ENRICHMENT);
  const { data, isLoading } = useCurrentTeamCredits({
    // A refetch mid job reads 0 on the last credit (reserved credits are
    // excluded) and unmounts the Enrich column, killing the row poll, so the
    // balance refetches only where it changes: enrich completion and a 402.
    query: {
      enabled: isFlagOn,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  });

  const availableCredits = data?.available_credits ?? 0;

  return {
    canEnrich: isFlagOn && !isLoading && availableCredits > 0,
    availableCredits,
    isLoading,
  };
};
